exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".main-activity-logs-container {\n  padding: 24px;\n  width: 100%;\n  height: 100%;\n  overflow-y: auto; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/app/components/activity-log/main-activity-log.scss
// module id = 0CLe
// module chunks = 0